import React from 'react';
import Styled from 'styled';

import { RouteWithSearchRenderProps as RouteWithSearchProps } from 'lib/react-router/route-with-search';
import observe from 'lib/intersection-observer/observe';

import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import PopularImages from 'four-nets/photoblog/popular-images/popular-images';
import { MediaKey } from 'four-nets/photoblog/masonry/masonry';

import RecommendedCollections from './recommended-collections/recommended-collections';
import AuthorCollections from './author-collections/author-collections';

import CollectionSlugLoader from '../collection-slug-loader/collection-slug-loader';
import Collection from './collection';
import defaultStyles from './collection.scss';

const columnsSizes: Map<MediaKey, number> = new Map([
    ['sm', 2],
    ['md', 4],
    ['lg', 6],
]);

interface Params {
    username: string;
    slug: string;
}

interface Props extends RouteWithSearchProps<Params, { offset: number }> {
    styles: typeof defaultStyles;
}

class CollectionLoader extends React.PureComponent<Props> {
    render() {
        const {
            styles,
            match: {
                params: { username, slug },
            },
            location: { pathname },
        } = this.props;

        return (
            <>
                <div className={styles.relative}>
                    <CollectionSlugLoader {...this.props}>{Collection as any}</CollectionSlugLoader>
                </div>
                <ViewerConsumer>
                    {({ viewer }) => (
                        <div className={styles.bottomWrapper}>
                            {!viewer || viewer.username !== username ? <RecommendedCollections /> : null}
                            <PopularImages
                                isPartOfOtherPage={true}
                                columnsSizes={columnsSizes}
                                pathname={pathname}
                                first={6}
                            />
                            <AuthorCollections
                                viewerIsAuthor={viewer && viewer.username === username}
                                slug={slug}
                                username={username}
                            />
                        </div>
                    )}
                </ViewerConsumer>
            </>
        );
    }
}

export default Styled(defaultStyles)(CollectionLoader);
